import { SVGFC } from '@repo/toolkit/types'

const NormalFaceIcon: SVGFC = ({ color = 'black', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.99996 9.71429H9.1428M14.857 9.71429H15.9999M7.99996 14.2857H15.9999M11.9999 20C10.9493 20 9.90907 19.7931 8.93848 19.391C7.96788 18.989 7.08598 18.3997 6.34312 17.6569C5.60026 16.914 5.01099 16.0321 4.60896 15.0615C4.20692 14.0909 4 13.0506 4 12C4 10.9494 4.20692 9.90914 4.60896 8.93853C5.01099 7.96793 5.60026 7.08601 6.34312 6.34315C7.08598 5.60028 7.96788 5.011 8.93848 4.60896C9.90907 4.20693 10.9493 4 11.9999 4C14.1216 4 16.1564 4.84285 17.6567 6.34315C19.157 7.84344 19.9998 9.87827 19.9998 12C19.9998 14.1217 19.157 16.1566 17.6567 17.6569C16.1564 19.1571 14.1216 20 11.9999 20Z"
        stroke={color}
        strokeWidth="1.14843"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default NormalFaceIcon
